<div class="container">
    <div class="close link" (click)="close()">Fermer <img src="/assets/spbfamily/close.svg" alt="Fermer"></div>

    <app-accordion-items *ngFor="let faq of FAQs; let index=index" [id]="index" [itemTitle]="faq.question" [itemBody]="faq.answer">
    </app-accordion-items>
</div>